var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 120,
    viewBox: "-12.5 -15 125 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.12l14.532 25.975v15.844L.017 93.863 0 26.12z",
    fill: "#5B57A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.797 42.643l13.617-8.346 27.868-.026-41.485 25.414V42.643z",
    fill: "#D90751"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.72 25.967l.077 34.39-14.566-8.95V0l14.49 25.967z",
    fill: "#FAB718"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.282 34.271l-27.869.026-13.693-8.33L41.231 0l56.05 34.271z",
    fill: "#ED6F26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.797 94.007V77.322l-14.566-8.78.008 51.458 14.558-25.993z",
    fill: "#63B22F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.38 85.737L14.531 52.095 0 26.12l97.223 59.583-27.844.034z",
    fill: "#1487C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.24 120l14.556-25.993 13.583-8.27 27.843-.034L41.24 120z",
    fill: "#017F36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M.017 93.863l41.333-25.32-13.896-8.526-12.922 7.922L.017 93.863z",
    fill: "#984995"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbp);
export default __webpack_public_path__ + "static/media/sbp.4a556dddac1fbcab2e7f85c06852f9c0.svg";
export { ForwardRef as ReactComponent };